import { Injectable } from "@angular/core";
import { ValidTheme } from "src/domain/themes";

@Injectable({
  providedIn: "root",
})
export class ThemeService {
  public brand?: ValidTheme;

  constructor() {}

  setBrand(brand: ValidTheme): void {
    this.brand = brand;
  }
}
